import Vue from 'vue';
import VueRouter from 'vue-router';
import SignUp from '@/views/SignUp.vue';
import StartChallenge from '@/views/StartChallenge.vue';
import Challenge from '@/views/Challenge.vue';
import Sample from '@/views/Sample.vue';

Vue.use(VueRouter);

const routes = [

    {
        path: '/',
        name: 'none',
        component: SignUp,
    },
    {
        path: '/:key',
        name: 'signUp',
        component: SignUp,
    },
    {
        path: '/:key/start',
        name: 'startChallenge',
        component: StartChallenge,
    },
    {
        path: '/:key/challenge',
        name: 'challenge',
        component: Challenge,
    },
    {
        path: '/:key/sample',
        name: 'sample',
        component: Sample,
    },
];

const router = new VueRouter({
    routes,
    mode: 'history',
});

export default router;
